import { combineReducers } from 'redux'
import uiFlags from './uiFlags'
import currentRecord from './currentRecord'
import records from './records'

export default combineReducers({
  uiFlags,
  currentRecord,
  records,
})
